import Swal from 'sweetalert2';

export function checkCatch(error) {

    let confirmButtonColor = '#608e9e';

    const colors = JSON.parse(localStorage.getItem('colors'));

    if (colors) {

        confirmButtonColor = colors.primary;

    }

    if (error.response) {

        // Sesión Expirada
        if (error.response.status == 401 || error.response.status == 419) {

            window.location = '/login';

        } else if (error.response.status == 422) { // Validaciones

            let data = String();

            if (error.response.data.errors) {

                $.each(error.response.data.errors, (key, value) => {

                    data += `<li>${value[0]}</li>`;

                });

            } else if (error.response.data.message) {

                data += `<li>${error.response.data.message}</li>`;

            }

            Swal.fire({
                title: 'Atención',
                icon: 'warning',
                html:
                    `Valida la siguiente información:
                    <div class="alert alert-danger text-left mt-2 mb-0 pl-0" role="alert">
                        <ul class="mb-0">
                            ${data}
                        </ul>
                    </div>`,
                showCloseButton: true,
                focusConfirm: true,
                confirmButtonText: 'Ok',
                confirmButtonColor,
            });

        } else if (error.response.status == 499) { // Restricciones

            Swal.fire({
                title: 'Atención',
                icon: 'warning',
                text: error.response.data.message,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                confirmButtonColor,
            }).then((result) => {

                if (result.value) {

                    window.location.reload();

                }

            });

        } else {

            console.log('Error -> ', error.message);

        }

    } else {

        console.log('Error -> ', error.message);

    }

}

export function showMessage(type, title, message) {

    let confirmButtonColor = '#608e9e';

    const colors = JSON.parse(localStorage.getItem('colors'));

    if (colors) {

        confirmButtonColor = colors.primary;

    }

    Swal.fire({
        icon: type,
        title,
        text: message,
        confirmButtonColor,
    });

}

export function showMessageHtml(type, title, message) {

    let confirmButtonColor = '#608e9e';

    const colors = JSON.parse(localStorage.getItem('colors'));

    if (colors) {

        confirmButtonColor = colors.primary;
        // this.secondaryColor = colors.secondary;

    }

    Swal.fire({
        icon: type,
        title,
        html: message,
        confirmButtonColor,
    });

}

export function showNotification(type, message) {

    Swal.fire({
        position: 'top-end',
        icon: type,
        text: message,
        showConfirmButton: false,
        timer: 2000,
    });

}

export function showLoading(message) {

    Swal.fire({
        html: `
            <div class="spinner-n"">
                <div class="double-bounce1-n"></div>
                <div class="double-bounce2-n"></div>
            </div>
            <br>
            ${message}
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
    });

}

export function closeLoading() {

    Swal.close();

}

export function noFoundMessage(message, returnPage) {

    Swal.fire({

        type: 'warning',
        title: 'Atención',
        text: message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        confirmButtonColor: '#d133d1',

    }).then((result) => {

        if (result.value) {

            window.location.href = returnPage;

        }

    });

}

export function redirectMessage(message, redirectPage) {

    Swal.fire({

        type: 'question',
        text: message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d133d1',

    }).then((result) => {

        if (result.value) {

            window.location.href = redirectPage;

        }

    });

}

export function paginationPages(visiblePages, currentPage, totalPages) {

    const pages = [];

    const half = Math.floor(visiblePages / 2);
    let start = currentPage - half + 1 - (visiblePages % 2);
    let end = currentPage + half;

    let vPages = visiblePages;

    if (vPages > totalPages) {

        vPages = totalPages;

    }

    if (start <= 0) {

        start = 1;
        end = vPages;

    }

    if (end > totalPages) {

        start = totalPages - vPages + 1;
        end = totalPages;

    }

    let itPage = start;

    while (itPage <= end) {

        pages.push(itPage);
        itPage += 1;

    }

    return pages;

}

export function getMonthName(month) {

    switch (month) {

    case 1:
        return 'Enero';

    case 2:
        return 'Febrero';

    case 3:
        return 'Marzo';

    case 4:
        return 'Abril';

    case 5:
        return 'Mayo';

    case 6:
        return 'Junio';

    case 7:
        return 'Julio';

    case 8:
        return 'Agosto';

    case 9:
        return 'Septiembre';

    case 10:
        return 'Octubre';

    case 11:
        return 'Noviembre';

    case 12:
        return 'Diciembre';

    default:
        break;

    }

    return null;

}

export function getUrlParam(parameter) {

    // eslint-disable-next-line no-useless-escape
    const results = new RegExp(`[\?&]${parameter}=([^&#]*)`).exec(window.location.href);

    if (results == null) {

        return null;

    }

    return decodeURI(results[1]) || 0;

}

export function numberFormat(value) {

    return value ? value.toLocaleString('en-US') : 0;

}

export function createCheckDigit(value) {

    if (Number.isNaN(Number(value))) {

        showMessage('warning', 'Atención', 'El número de documento de indentidad no es válido.');
        return String();

    }

    const aPattern = [];
    let x = 0;
    let y = 0;
    const z = value.length;

    aPattern[1] = 3;
    aPattern[2] = 7;
    aPattern[3] = 13;
    aPattern[4] = 17;
    aPattern[5] = 19;
    aPattern[6] = 23;
    aPattern[7] = 29;
    aPattern[8] = 37;
    aPattern[9] = 41;
    aPattern[10] = 43;
    aPattern[11] = 47;
    aPattern[12] = 53;
    aPattern[13] = 59;
    aPattern[14] = 67;
    aPattern[15] = 71;

    for (let i = 0; i < z; i++) {

        y = (value.substr(i, 1));
        x += (y * aPattern[z - i]);

    }

    y = x % 11;

    if (y > 1) {

        return 11 - y;

    }

    return y;

}

export function formatDate(date, hour) {

    if (!date && !hour) {

        return null;

    }

    let localDate = date;

    localDate = new Date(localDate);

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();

    if (!hour) {

        // eslint-disable-next-line prefer-template
        return ('0' + day).slice(-2) + '/' + ('0' + month).slice(-2) + '/' + year;

    }

    let localHour = hour;

    localHour = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    // eslint-disable-next-line prefer-template
    return ('0' + day).slice(-2) + '/' + ('0' + month).slice(-2) + '/' + year + ' ' + ('0' + localHour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);

}

export function validateEmail(email) {

    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());

}

export function activateTooltips() {

    setTimeout(() => {

        $('[data-toggle="tooltip"]').tooltip();

    }, 700);

}

export function getOnlyNumbersFromString(value) {

    if (value) {

        // eslint-disable-next-line radix
        const resp = parseInt(value.replace(/[^0-9]/gi, ''));

        return Number.isNaN(Number(resp)) ? null : resp;

    }

    return 0;

}

export function getOnlyLettersFromString(value) {

    if (value) {

        return value.toString().replace(/[^a-z]/gi, '').toUpperCase();

    }

    return null;

}

export function capitalize(value) {

    if (value.length > 0) {

        return value.charAt(0).toUpperCase() + value.slice(1);

    }

    return '';

}

export function getFileIconByName(fileName) {

    let icon = String();

    if (/\.(pdf)$/i.test(fileName)) { // PDF

        icon = 'far fa-file-pdf';

    } else if (/\.(doc|docx|dotx|docm)$/i.test(fileName)) { // Word

        icon = 'far fa-file-word';

    } else if (/\.(xls|xlsx|xlsm|xltx|xltm)$/i.test(fileName)) { // Excel

        icon = 'far fa-file-excel';

    } else if (/\.(ppt|pptx|pptm|ppsx|sldx|potx)$/i.test(fileName)) { // Power Point

        icon = 'far fa-file-powerpoint';

    } else if (/\.(gif|jpg|jpeg|png|webp|svg|tiff|bmp|raw|ai|psd)$/i.test(fileName)) { // Imágenes

        icon = 'far fa-file-image';

    } else if (/\.(mkv|flv|avi|wmv|amv|mp4|webm|m4p|mov|qt|swf|ogg)$/i.test(fileName)) { // Vídeos

        icon = 'far fa-file-video';

    } else if (/\.(mp3|wma|wav|aac|flac|alac)$/i.test(fileName)) { // Audio

        icon = 'far fa-file-audio';

    } else if (/\.(txt|rtf)$/i.test(fileName)) { // Texto

        icon = 'far fa-file-alt';

    } else if (/\.(zip|rar|7z|tar|gz)$/i.test(fileName)) { // Comprimidos

        icon = 'far fa-file-archive';

    } else { // Otras extensiones

        icon = 'far fa-file';

    }

    return icon;

}

export function shadeColor(color, percent) {

    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * ((100 + percent) / 100), 10);
    G = parseInt(G * ((100 + percent) / 100), 10);
    B = parseInt(B * ((100 + percent) / 100), 10);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    const RR = ((R.toString(16).length == 1) ? `0${R.toString(16)}` : R.toString(16));
    const GG = ((G.toString(16).length == 1) ? `0${G.toString(16)}` : G.toString(16));
    const BB = ((B.toString(16).length == 1) ? `0${B.toString(16)}` : B.toString(16));

    return `#${RR}${GG}${BB}`;

}

export function generateToken(size) {

    const rand = () => Math.random(0).toString(36).substr(2);
    const token = (length) => (rand() + rand() + rand() + rand()).substr(0, length);

    return token(size);

}

export function injectCss(style) {

    return new Promise((resolve) => {

        const styleSheet = document.createElement('link');
        styleSheet.setAttribute('rel', 'stylesheet');
        styleSheet.setAttribute('type', 'text/css');
        styleSheet.setAttribute('href', style);

        document.getElementsByTagName('head')[0].appendChild(styleSheet);

        setTimeout(() => {

            resolve(`Style: ${style} loaded successfully`);

        }, 1000);

    });

}

export function userLocale() {

    try {

        return navigator.languages && navigator.languages.length
            ? navigator.languages[0]
            : navigator.language;

    } catch (error) {

        return 'es-ES';

    }

}

export function getTemplateId() {

    const template = JSON.parse(localStorage.getItem('template_id'));

    return template || 1;

}

export function hasNumber(myString) {

    return /\d/.test(myString);

}

export function createUUID() {

    let dt = new Date().getTime();

    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {

        // eslint-disable-next-line no-bitwise
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);

        return (c == 'x' ? r : (r && (0x3 || 0x8))).toString(16);

    });

    return uuid;

}
